/**
 * Converte as declaracoes `nav` dos modulos no mapa que o buildMenu consome.
 *
 * Separado do navRegistry porque este arquivo nao pode depender do Vite: e
 * assim que ele fica testavel com `node --test`.
 */
export function navDosModulos(modulos = {}) {
    return Object.values(modulos).reduce((mapa, modulo) => {
        const nav = modulo?.nav;

        if (!nav?.section || !nav?.title) {
            return mapa;
        }

        mapa[`${nav.section}/${nav.title}`] = {
            icon: nav.icon,
            route: nav.route,
            accordion: nav.accordion ?? false,
        };

        return mapa;
    }, {});
}

/**
 * As declaracoes `nav` cruas, como os modulos escreveram.
 *
 * O `navDosModulos` acima achata para o mapa por caminho de titulos, que era o
 * que o buildMenu antigo consumia. Este devolve o objeto inteiro -- com
 * `section`, `permissao` e `sequence` -- porque o `montarMenu` monta a
 * estrutura a partir dele, sem passar por casamento de texto.
 */
export function navsDosModulos(modulos = {}) {
    return Object.values(modulos)
        .map((modulo) => modulo?.nav)
        .filter((nav) => nav?.title && nav?.route);
}

/**
 * Lista plana dos modulos declarados, ordenada por `sequence` (como o menu
 * normal -- ver `ordenar()` em `menuDosModulos.js`) em vez da ordem do glob.
 *
 * O menu normal vem da arvore de permissoes do /appmenu. Este aqui e a rede de
 * seguranca: usuario de grupo admin ignora a arvore, e enquanto o catalogo
 * proprio do accounts nao estiver cadastrado a arvore volta vazia para todo
 * mundo. Sem isto, quem precisa entrar para *criar* o catalogo nao teria como
 * navegar ate a tela.
 *
 * A ordenacao existe para o "Meu perfil" (sequence negativo) tambem ser o
 * primeiro item aqui -- sem ela, a ordem seguia o glob (alfabetica por pasta
 * de modulo), e "perfil" cairia no meio da lista para quem ve este menu.
 */
export function modulosDeclarados(modulos = {}) {
    return Object.values(modulos)
        .map((modulo) => modulo?.nav)
        .filter((nav) => nav?.title && nav?.route)
        .sort((a, b) => {
            const sa = a.sequence ?? 0;
            const sb = b.sequence ?? 0;
            if (sa !== sb) {
                return sa - sb;
            }
            return String(a.title).localeCompare(String(b.title), 'pt-BR');
        })
        .map((nav) => ({ title: nav.title, icon: nav.icon || 'folder', route: nav.route }));
}
